import React from "react";
import WhatOffer from "./WhatOffer";
import LoveWeb5 from "./LoveWeb5";
import HowWorks from "./HowWorks";
// import FullCycle from './FullCycle';
import TestimonialCarousel from "./TestimonialCarousel";
import ContactUsForm2 from "./ContactUsForm2";
import IndustriesWeServe from "./IndustriesWeServe";
import OurTeam from "./OurTeam";
import OurNetworks from "./OurNetworks";
import LatestBlogs from "./LatestBlogs";
import ServicesSection from "./ServicesSection";
import SeoHelmet from "./SeoHelmet";

const Home = () => {
  return (
    <div className="home">
      <SeoHelmet
        title="Blockchain, AI and Metaverse Development Company"
        description="Explore Web5Solution's blockchain, AI, automation, and metaverse development services built to help enterprises launch secure, scalable digital products."
        path="/"
      />
      <WhatOffer />
      {/* <ServicesSection /> */}
      <LoveWeb5 />
      <HowWorks />
      <IndustriesWeServe />
      <OurTeam />
      <OurNetworks />
      <LatestBlogs />
      <TestimonialCarousel />
      <ContactUsForm2 />
    </div>
  );
};

export default Home;
